import React, { Component } from 'react';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import ServicePage from '../../../shared/servicePage/ServicePage';
import getNextImageData from './GetNextImage.json';
import '../../Technical.css';

class GetNextImage extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <ServicePage ServiceData ={getNextImageData} backLink="/technical/imagedelivery2"/>
            </div>
            )
        }
    }
            
export default GetNextImage;